
























































































import {
  Vue,
  Prop,
  Component,
  Watch
} from "@/shared/vuepack";
import moment from "moment";
import {
  SigningDocument,
  UserPermission,
  AgreementCategory,
  SigningDocumentContentType
} from "@/shared/types";
import * as RouteNames from "@/admin/route-names";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({})
export default class SigningDocumentEditor extends Vue {

  SigningDocumentContentType = SigningDocumentContentType;
  signingDocumentStore = useSigningDocumentStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();

  todayAsString = moment().format("YYYY-MM-DD");

  @Prop()
  documentId: number;

  @Prop()
  version: number;

  model: SigningDocument = {
    documentId: 0,
    version: 0.0,
    name: "",
    content: "",
    documentKey: "",
    agreementCategory: AgreementCategory.Investment,
    dateCreated: this.todayAsString,
    contentType: SigningDocumentContentType.Html,
    documentUrl: "",
    pathToFile: null
  };

  file = null;

  @Watch("documentId")
  onDocumentIdChange () {
    this.load();
  }

  load () {
    if (this.documentId !== null && this.documentId !== undefined && this.documentId > 0) {
      this.signingDocumentStore.getByIdAdmin({ documentId: this.documentId, version: this.version });
    }
  }

  @Watch("signingDocumentStore.currentDocument", { deep: true })
  onDocumentChange () {
    this.model.documentId = this.signingDocumentStore.currentDocument.documentId;
    this.model.version = this.signingDocumentStore.currentDocument.version;
    this.model.name = this.signingDocumentStore.currentDocument.name;
    this.model.content = this.signingDocumentStore.currentDocument.content;
    this.model.documentKey = this.signingDocumentStore.currentDocument.documentKey;
    this.model.agreementCategory = this.signingDocumentStore.currentDocument.agreementCategory;
    this.model.contentType = this.signingDocumentStore.currentDocument.contentType;
    this.model.documentUrl = this.signingDocumentStore.currentDocument.documentUrl;
  }

  mounted () {
    this.load();
  }

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalDocumentEdit)
        : true;
  }

  get contentTypesEnabled (): boolean {
    return this.featureFlagStore.flags.bend21504EnableContentTypes;
  }

  get agreementCategoryOptions () {
    return [
      { value: AgreementCategory.Investment, text: "Investment" },
      { value: AgreementCategory.Claims, text: "Claims" },
      { value: AgreementCategory.Other, text: "Other" },
    ];
  }

  get contentTypeOptions () {
    return [
      { value: SigningDocumentContentType.Html, text: "Html" },
      { value: SigningDocumentContentType.Pdf, text: "Pdf" },
    ];
  }

  onSubmit () {
    this.$validator.validate().then(result => {
      if (result) {
        this.signingDocumentStore.save(this.model, this.file).then(() => {
          this.$router.push({ name: RouteNames.SigningDocuments });
        });
      }
    });
  }
}
